module.exports = __webpack_public_path__ + "static/media/myntra_logo.f9a48a60.svg";